/**
 * @file index.tsx
 *
 * @fileoverview Aligns an element center vertically.
 */

import styles from "../Alignment.module.scss";

/**
 * Vertically centers any element within its container (flex).
 */
export default function VerticallyCentered({ children }) {
  return <div className={styles.verticallyCentered}>{children}</div>;
}
export { VerticallyCentered };
